import { createActionTypes } from "@src/utility"

export const DASHBOARD = createActionTypes("DASHBOARD", [
  "GET_STATS_REQUEST",
  "GET_STATS_SUCCESS",
  "GET_STATS_FAIL",

  "GET_APPLICANTS_STATUS_REQUEST",
  "GET_APPLICANTS_STATUS_SUCCESS",
  "GET_APPLICANTS_STATUS_FAIL",

  "GET_APPLICANTS_REPORT_REQUEST",
  "GET_APPLICANTS_REPORT_SUCCESS",
  "GET_APPLICANTS_REPORT_FAIL",

  "GET_TOTAL_JOBS_AND_APPLICANT_REQUEST",
  "GET_TOTAL_JOBS_AND_APPLICANT_SUCCESS",
  "GET_TOTAL_JOBS_AND_APPLICANT_FAIL",

  "GET_TOTAL_APPLICANTS_REPORTS_REQUEST",
  "GET_TOTAL_APPLICANTS_REPORTS_SUCCESS",
  "GET_TOTAL_APPLICANTS_REPORTS_FAIL",

  "GET_OPEN_JOB_BY_CATEGORY_REQUEST",
  "GET_OPEN_JOB_BY_CATEGORY_SUCCESS",
  "GET_OPEN_JOB_BY_CATEGORY_FAIL",

  "GET_TOTAL_APPLICANTS_FUNNEL_REQUEST",
  "GET_TOTAL_APPLICANTS_FUNNEL_SUCCESS",
  "GET_TOTAL_APPLICANTS_FUNNEL_FAIL",

  "GET_APPLICATIONS_RECEIVED_BY_CATEGORY_REQUEST",
  "GET_APPLICATIONS_RECEIVED_BY_CATEGORY_SUCCESS",
  "GET_APPLICATIONS_RECEIVED_BY_CATEGORY_FAIL",

  "GET_JOB_POST_BY_JOB_TYPE_REQUEST",
  "GET_JOB_POST_BY_JOB_TYPE_SUCCESS",
  "GET_JOB_POST_BY_JOB_TYPE_FAIL",

  "GET_JOB_ACCEPTED_RATIO_REQUEST",
  "GET_JOB_ACCEPTED_RATIO_SUCCESS",
  "GET_JOB_ACCEPTED_RATIO_FAIL",

  "GET_JOB_BY_TITLE_REQUEST",
  "GET_JOB_BY_TITLE_SUCCESS",
  "GET_JOB_BY_TITLE_FAIL",

  "GET_LOCATION_DATA_REQUEST",
  "GET_LOCATION_DATA_SUCCESS",
  "GET_LOCATION_DATA_FAIL",

  "GET_APPLICANT_BY_GENDER_REQUEST",
  "GET_APPLICANT_BY_GENDER_SUCCESS",
  "GET_APPLICANT_BY_GENDER_FAIL"
])
